// author: zhangmyh lx
// latest: zhangmyh 2017-3-9 2:41 PM
/* global u */
import orgPerson from './orgPerson'
import person from 'components/modalrefer/person'
import evaluator from 'components/modalrefer/evaluator'

// 人员refer
function personrefer (option) {
  u.refer({
    isPOPMode: true,
    module: person,
    okId: 'okBtn',
    contentId: 'refer',
    width: '800px',
    title: '选择人员',
    onOk: option.onOk,
    enterpriseId: window.global.user.enterpriseId,
    onCancel: option.onCancel
  })
}

function evaluatorrefer (option) {
  u.refer({
    isPOPMode: true,
    module: evaluator,
    okId: 'okBtn',
    contentId: 'refer',
    width: '800px',
    title: '选择人员',
    onOk: option.onOk,
    enterpriseId: window.global.user.enterpriseId,
    onCancel: option.onCancel
  })
}

// 组织人员参照
function orgPersonRefer (option) {
  u.refer({
    defaultData: option.defaultData,
    isPOPMode: true,
    module: orgPerson(option.args),
    okId: 'okBtn',
    contentId: 'refer',
    width: '800px',
    title: '选择人员',
    onOk: option.onOk,
    enterpriseId: window.global.user.enterpriseId,
    onCancel: option.onCancel
  })
}

export {
  orgPersonRefer,
  evaluatorrefer,
  personrefer
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/index.js